import React from 'react'
import styled from 'styled-components'
import media from 'utils/media-queries'
import Header from 'components/header'
import SectionTopComponent from 'components/top-section'
import HeaderArticle from 'components/article/header'


const HeroSection = styled.section`
  height: 100%;
  max-height: 300vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
  text-align: left;
  ${media.sm`
    height: 100%;
    p + h3 {
      margin-top: 42px;
    }
  `}
  
`


function Hero() {
  return (
    <HeroSection>
      <Header />
      <SectionTopComponent>
        <HeaderArticle title="Winnebago County CJCC Dashboard"  />
          <p> In June 2018, Winnebago County, Illinois formally established its Criminal Justice Coordinating Council (CJCC),
             which meets on a quarterly basis to provide an ongoing collaborative forum to study the Winnebago County juvenile and criminal justice system, identify deficiencies, and formulate policy, plans, and programs for change when opportunities present themselves.
             </p>
          <p>The Winnebago County CJCC uses a data-guided and structured planning process to identify, analyze, solve, and manage justice system issues. Technical assistance in the form of research, analysis, and facilitated strategic planning has been provided by Loyola University Chicago’s Center for Criminal Justice Research, Policy, and Practice and the Region 1 Planning Council.</p>
          <p>This dashboard is designed to provide criminal justice practitioners, policy makers, community organizers, and members of the general public with the most current data regarding workloads and activities across all of the major components of the justice system. A more detailed report examining the structure and activities of the Winnebago County, Illinois criminal justice system can be found <a href='https://www.luc.edu/media/lucedu/ccj/pdfs/Winnebago%20Trends%20and%20Issues%20Report.pdf'> here</a>. </p>
        
      </SectionTopComponent>
    
    </HeroSection>
  )
}
export default Hero
